import { useParams } from 'react-router-dom';
import { createContext } from 'react';

import useGetPharmacyService from '../hooks/useGetPharmacyService';

export const ServiceContext = createContext(null);

export default function ServiceProvider({ children }) {
  const { serviceId } = useParams();

  const {
    data: service,
    isLoading: isServiceLoading,
    error,
  } = useGetPharmacyService({ serviceId });

  return (
    <ServiceContext.Provider value={{ service, isServiceLoading, error }}>
      {children}
    </ServiceContext.Provider>
  );
}
